<template>
    <article v-if="model" class="profile-container short-header">
        <image-viewer :images="getImageObjects()" :thumbnails="getImageObjects()" :placeholder="{}"></image-viewer>
        <div id="profileContent">
            <div class="header">
                <h1 class="profileHeader">{{ model.name }}</h1>
            </div>
            <div id="about">
                <p class="body"> {{ model.description }}</p>
            </div>
        </div>
    </article>
</template>

<script>
import { mapGetters } from 'vuex'
import ImageViewer from '@/components/ImageViewer'

export default {
    name: "ThemeProfile",
    components: {
        ImageViewer
    },
    computed: {
        ...mapGetters({
            'model' : 'themes/item',
        }),
    },
    methods: {
        getImageObjects() {
            let images = [];

            if (this.model && this.model.image) {
                images.push({
                    src: `${this.$rootUrl()}${this.model.image}`,
                    title: this.model.image_title
                });
            }

            return images;
        }
    },
}
</script>
